import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState, mapActions } from 'vuex';
export default {
    data: function data() {
        return {
            dialog: false,
            sending: false
        };
    },

    methods: {
        showModal: function showModal() {
            this.dialog = true;
        },
        close: function close() {
            this.dialog = false;
        },
        closeSession: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
                var state = _ref.state,
                    commit = _ref.commit;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                if (!(this.$router.history.current.path === '/new-affiliation' && this.productChoice)) {
                                    _context.next = 5;
                                    break;
                                }

                                this.$store.commit('affiliations/form/setLogout', true);
                                _context.next = 7;
                                break;

                            case 5:
                                _context.next = 7;
                                return this.$store.dispatch('user/loginOut');

                            case 7:
                                this.$router.push('/');
                                this.dialog = false;
                                _context.next = 14;
                                break;

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context['catch'](0);

                                this.$controlMessage(_context.t0);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 11]]);
            }));

            function closeSession(_x) {
                return _ref2.apply(this, arguments);
            }

            return closeSession;
        }()
    },
    computed: _extends({}, mapState({
        productChoice: function productChoice(state) {
            return state.affiliations.form.productChoice;
        }
    }))
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/close-session-modal.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/close-session-modal.vue
// module chunks = 34